
// SVG Icon: checkbox-off
export default { id: "terriajs-checkbox-off" };
export const id = "terriajs-checkbox-off";
export const name = "checkbox-off";
